var map = {
	"./music-instructions.json": 5134,
	"./music-library-intro2024.json": 5135,
	"./music-library-launch2024.json": 5136,
	"./music-progression.json": 5137,
	"./startSourcesAdvanced.json": 5138,
	"./startSourcesSimple.json": 5139,
	"./startSourcesSimple2.json": 5140,
	"./startSourcesTracks.json": 5141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4834;